import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "color-picker-input" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "color-picker-input__mode" }, "HEXA", -1)

import { normalizeHexaUnit } from '@/utils/transformColor'
import Color from 'color'
import { onMounted, ref } from 'vue'
import ColorInputUnit from './colorInputUnit.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'colorInput',
  props: {
    color: null
  },
  emits: ['update:color'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  color: string
}


const inputValue = ref(props.color)

onMounted(() => {
  try {
    const value = Color(props.color)
    inputValue.value = value.hexa()
  } catch (error) {
    inputValue.value = ''
  }
})



const handleChangeInput = async (input: string) => {
  const valid = normalizeHexaUnit(input)
  if (valid) {
    emit('update:color', input)
  }
  inputValue.value = input
}

const handleUpdateValue = (input: string) => {
  inputValue.value = input
}

const updateInput = (val: string) => {
  inputValue.value = val
}

expose({
  updateInput
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ColorInputUnit, {
      label: "HEX",
      inputValue: inputValue.value,
      "onUpdate:inputValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      handleChange: handleChangeInput,
      handleUpdateValue: handleUpdateValue
    }, null, 8, ["inputValue"])
  ]))
}
}

})